"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.magnet = void 0;
/* eslint-disable max-len */

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var magnet = function magnet(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  var classes = (0, classnames_1["default"])('helix-icon', 'magnet-outlined', className);
  return react_1["default"].createElement("svg", Object.assign({
    className: classes,
    width: '20',
    height: '20',
    viewBox: '0 0 20 20',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    "aria-hidden": 'true'
  }, rest), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M9.96967 4.75013C6.53184 4.76647 3.75 7.5584 3.75 11.0001C3.75 14.4417 6.53185 17.2337 9.96968 17.25L14.5623 16.8673C14.9514 16.8348 15.25 16.5102 15.25 16.1205V15.5001H16.75V16.1205C16.75 17.2911 15.8526 18.2649 14.6869 18.3621L10.0312 18.7501H10C5.71979 18.7501 2.25 15.2803 2.25 11.0001C2.25 6.71986 5.71979 3.25006 10 3.25006L10.0312 3.25006L14.6869 3.63803C15.853 3.73521 16.75 4.71006 16.75 5.88026V7.00006L15.25 7.00006V5.88026C15.25 5.49019 14.951 5.16525 14.5623 5.13285L9.96967 4.75013Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M16.75 7.00006V7.41766C16.75 8.43867 15.8795 9.24287 14.8617 9.16218L9.66545 8.75029C8.67701 8.76676 7.75 9.69088 7.75 11.0001C7.75 12.3092 8.67701 13.2334 9.66545 13.2498L14.8617 12.8379C15.8795 12.7573 16.75 13.5615 16.75 14.5825V15.5001H15.25V14.5825C15.25 14.4366 15.1256 14.3217 14.9802 14.3332L9.72199 14.7501H9.69231C7.7169 14.7501 6.25 12.9927 6.25 11.0001C6.25 9.00739 7.7169 7.25006 9.69231 7.25006H9.72198L14.9802 7.66687C15.1256 7.6784 15.25 7.56352 15.25 7.41766V7.00006L16.75 7.00006Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M12 8.00006V4.00006L13.5 4.00006V8.00006H12Z',
    fill: '#4B5563'
  }), react_1["default"].createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M12 18.0001V14.0001H13.5V18.0001H12Z',
    fill: '#4B5563'
  }));
};

exports.magnet = magnet;